module.exports = __webpack_public_path__ + "fonts/Inter-200-vietnamese33.9df1755.woff2";